export const listColors = [
  '#55e0d9',
  '#57d8e8',
  '#57d5e9',
  '#57d2ea',
  '#57cdec',
  '#56b3f9',
  '#7795e6',
  '#a979be',
  '#ff4a7a',
];
